import React from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { BookCreationWizardContainer } from '../components/book-creation/BookCreationWizardContainer';
import { Config } from '../services/Config';
import { OnboardingProvider } from '../services/routing/OnboardingProvider';
import { SubscriptionProvider } from '../services/Subscription/SubscriptionProvider';

export const Route = createFileRoute('/book-creation')({
  staticData: {
    secure: true,
  },
  component: BookCreationRoute,
});

function handleCancelClick() {
  window.location.href = Config.APPLICATION_RECKON_LOGIN_URL;
}

function BookCreationRoute() {
  return (
    <OnboardingProvider>
      <SubscriptionProvider>
        <BookCreationWizardContainer onCancelClick={handleCancelClick} />
      </SubscriptionProvider>
    </OnboardingProvider>
  );
}
